import React from 'react'
import './index.css'

function Parrafo() {
    return (
        <div className='parrafo'>
            <span>
                Launchpad and marketing revenue is generated from the
                value of the tier your partner took a seat at. Therefore,
                working at higher levels increases your results.
            </span>
        </div>
    )
}

export default Parrafo